import styled from '@emotion/styled';
import { colors, Stack, Typography } from '@ui-components/neo.tax';

export const CellContainer = styled(Stack)({
  minWidth: 80,
});

export const StatusDot = styled('span')<{ $isCapitalized: boolean }>(({ $isCapitalized }) => ({
  width: 6,
  height: 6,
  borderRadius: '50%',
  backgroundColor: $isCapitalized ? colors.green[500] : colors.gray[300],
  flexShrink: 0,
}));

export const StatusText = styled(Typography)<{ $isCapitalized: boolean }>(({ $isCapitalized }) => ({
  color: $isCapitalized ? colors.gray[700] : colors.gray[400],
}));

export const EditButton = styled(Typography)<{ $isVisible: boolean }>(({ $isVisible }) => ({
  opacity: $isVisible ? 1 : 0,
  transition: 'opacity 150ms ease',
  cursor: 'pointer',
  '&:hover': {
    color: colors.primary[600],
  },
}));
